import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import { request } from "../../../../utils/Request";
import UrlHelper from "js-url-helper";
import ProviderList from "./partials/ProviderList";
import qs from "qs";
import { Route, Routes } from "react-router-dom";
import { Toast } from "primereact/toast";
import { getFromStorage, setToStorage } from "../../../../utils/Helper";

const DEFAULT_DROPDOWNS = {};
const url = new UrlHelper();

const Provider = (props: any) => {
    const { t } = props;
    const toast = useRef(null);
    const [dropdowns, setDropdowns] = useState<any>(null);
    const [moduleState, setModuleState] = useState<any>({
        page: 1,
        per_page: 20,
        search: null,
        initialized: false,
        sort_field: null,
        sort_order: null,
    });

    const getDropdowns = async () => {
        try {
            const response = await request({
                url: "/suppliers/settings/providers/create",
                params: { type: "list" },
            });
            const { data } = response.data;
            setDropdowns(data);
        } catch (e) {
            setDropdowns(DEFAULT_DROPDOWNS);
        } finally {
            const prevUrl = qs.parse(url.getSearchParam().prev_url ?? "");
            const fromStorage: any = getFromStorage("supplierSettingsProviderModuleState");
            const savedState = !isEmpty(fromStorage) ? JSON.parse(fromStorage) : {};

            const defaultState = {
                page: !isEmpty(prevUrl.page)
                    ? parseInt(url.getSearchParam().page)
                    : (!isEmpty(savedState.page) ? savedState.page : 1),
                per_page: !isEmpty(prevUrl.per_page)
                    ? parseInt(url.getSearchParam().per_page)
                    : (!isEmpty(savedState.per_page) ? savedState.per_page : 20),
                search: !isEmpty(prevUrl.search)
                    ? url.getSearchParam().search
                    : (!isEmpty(savedState.search) ? savedState.search : null),
                sort_field: !isEmpty(savedState.sort_field) ? savedState.sort_field : null,
                sort_order: !isEmpty(savedState.sort_order) ? savedState.sort_order : null,
                filters: !isEmpty(savedState.filters) ? savedState.filters : [],
                initialized: true,
            };

            setModuleState(defaultState);
            setToStorage("supplierSettingsProviderModuleState", JSON.stringify(defaultState));
        }
    };

    useEffect(() => {
        document.title = t("providers");
        getDropdowns();
    }, []);

    const toastify = (message: any, color: string = "info", summary: any = null) => {
        if (toast && toast.current) {
            // @ts-ignore
            toast.current.show({ severity: color, summary: summary, detail: message });
        }
    };

    const setQuery = (value: any) => {
        setToStorage("supplierSettingsProviderModuleState", JSON.stringify(value));
        setModuleState(value);
    };

    return (
        <div className={ "module-container" }>
            <Toast ref={ toast } />
            <div className="layout-content">
                {(moduleState && moduleState.initialized) ? (
                    <React.Fragment>
                        <Routes>
                            <Route
                                path={ "/" }
                                element={
                                    <ProviderList
                                        moduleState={ moduleState }
                                        dropdowns={ dropdowns }
                                        toastify={ toastify }
                                        setQuery={ setQuery }
                                    />
                                }
                            />
                        </Routes>
                    </React.Fragment>
                ) : (
                    <h6>{ t("loading") }</h6>
                )}
            </div>
        </div>
    );
};

export default withTranslation()(Provider);
